import { FC } from 'react';
// Components
import Dialog from 'components/Dialog';
import { Button } from 'components/Buttons';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  onClose: () => void;
}

const AudioAlertDialog:FC<Props> = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog background='none' classes="backdrop-blur-sm">
      <div className="relative mx-4 p-4 border border-white rounded-xl bg-[#212938]">
        <h3 className="text-lg text-white text-center mb-4">
          {t('dialogs.audioAlert.title')}
        </h3>
        <p className="text-sm text-white font-bold mb-4">
          {t('dialogs.audioAlert.message')}
        </p>
        <Button
          size="small"
          onClick={onClose}
          className="bg-linear-orange flex items-center gap-2 mx-auto"
        >
          {t('buttons.proceed')}
        </Button>
      </div>
    </Dialog>
  )
}

export default AudioAlertDialog;
